import Vue from 'vue';
import VueRouter from 'vue-router';

import OrganizationSummary from '../views/OrganizationSummary.vue';
import ProgramSummary from '../views/ProgramSummary.vue';
import Allocation from '../views/Allocation.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    beforeEnter: (to, from, next) => next('/organization-summary'),
  },
  {
    path: '/organization-summary',
    name: 'organization-summary',
    component: OrganizationSummary,
  },
  {
    path: '/program-summary',
    name: 'program-summary',
    component: ProgramSummary,
  },
  {
    path: '/allocation/:allocationId',
    name: 'allocation',
    component: Allocation,
  },
];

const router = new VueRouter({
  base: process.env.NODE_ENV === 'production' ? '/' : '/Allocations_Public/',
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

export default router;
